'use client';

import React, { forwardRef } from 'react';
import { cn } from '@/components/ui/_lib/cn';
import type { UiSkeletonProps } from '@/components/ui/_lib/skeletonProps';
import { useDeferredSkeleton } from '@/components/ui/_lib/useDeferredSkeleton';
import { SkeletonLines } from '@/components/ui/_lib/SkeletonLines';
import { SKELETON_BY_COMPONENT } from '@/components/ui/_lib/skeletonRegistry';

export type OlProps = React.OlHTMLAttributes<HTMLOListElement> & UiSkeletonProps;

const sk = SKELETON_BY_COMPONENT.Ol;

const Ol = forwardRef<HTMLOListElement, OlProps>((props, ref) => {
  const {
    skeleton = false,
    skeletonMaxWaitMs = 2000,
    skeletonLines,
    className,
    children,
    ...domProps
  } = props;

  const showSkeleton = useDeferredSkeleton(skeleton, skeletonMaxWaitMs);

  return (
    <ol       ref={ref}
      className={cn('group', 'ol', className)}
      {...domProps}
    >
      <SkeletonLines show={showSkeleton} shape={sk.shape} lines={skeletonLines ?? sk.lines}>
        {children}
      </SkeletonLines>
    </ol>
  );
});

Ol.displayName = 'Ol';

export default Ol;
